<template>
  <div v-if="items && items.length">
    <b-alert
      show
      variant="danger"
    >
      <h4 class="alert-heading">
        Los aspirantes señalados a continuación, ya se encuentran registrados en el plan y periodo seleccionados:
      </h4>

      <div class="alert-body">
        <div
          v-for="(error, index) in items"
          :key="error.id"
        >
          <p>
            Nombre: <strong>{{ error.nombreCompleto }}</strong>
          </p>
          <p>
            CURP: <strong>{{ error.curp }}</strong>
          </p>
          <p>
            Email: <strong>{{ error.email }}</strong>
          </p>

          <hr
            v-if="index < items.length - 1"
          >
        </div>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { BAlert } from 'bootstrap-vue'

export default {
  name: 'UsersAlreadyRegisteredList',
  components: {
    BAlert,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
